"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
import classNames from "classnames";
import React from "react";
import Tooltip from "../Tooltip/Tooltip";
import { handleMouseUpByBlurring } from "../../../utils/focus";
export var OptionGroupSize = /* @__PURE__ */function (OptionGroupSize2) {
  OptionGroupSize2["Small"] = "small";
  OptionGroupSize2["Large"] = "large";
  return OptionGroupSize2;
}(OptionGroupSize || {});
var OptionGroup = function OptionGroup(props) {
  var options = props.options,
    selectedValue = props.selectedValue,
    onClickHandler = props.onClickHandler;
  var size = props.size || "small" /* Small */;
  var optionComponents = options.map(function (option, index) {
    return renderOption(size, option, selectedValue, onClickHandler, index, options.length);
  });
  return /* @__PURE__ */React.createElement("div", {
    className: "option-group"
  }, props.label && /* @__PURE__ */React.createElement("div", {
    className: "option-group__label"
  }, props.label), /* @__PURE__ */React.createElement("div", {
    className: classNames("option-group__content", "option-group__content--".concat(size))
  }, optionComponents));
};
export var StricterOptionGroup = function StricterOptionGroup(props) {
  return /* @__PURE__ */React.createElement(OptionGroup, __spreadValues({}, props));
};
var renderOption = function renderOption(size, option, selectedValue, onClickHandler, index, length) {
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    onClickHandler(option.value);
  };
  var optionComponent = /* @__PURE__ */React.createElement("button", {
    key: option.value.toString(),
    className: classNames("option-group__button", "option-group__button--".concat(size), "center", {
      "option-group__button--selected": selectedValue === option.value,
      "option-group__button--first": index === 0,
      "option-group__button--last": index === length - 1
    }),
    onClick: handleClick,
    onMouseUp: handleMouseUpByBlurring
  }, /* @__PURE__ */React.createElement("div", {
    className: "option-group__button-content center"
  }, renderOptionContent(option)));
  if (option.tooltipMessage !== void 0) {
    return /* @__PURE__ */React.createElement(Tooltip, {
      key: option.value.toString(),
      content: option.tooltipMessage
    }, optionComponent);
  } else {
    return optionComponent;
  }
};
var renderOptionContent = function renderOptionContent(option) {
  if (option.icon) {
    return option.icon;
  } else {
    return option.label;
  }
};
export default OptionGroup;